import React from 'react';

export default function ConsultingIcon(props) {
  return (
    <svg
      version='1.1'
      id='Capa_1'
      xmlns='http://www.w3.org/2000/svg'
      xlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 488 488'
      xmlSpace='preserve'
      {...props}
    >
      <g>
        <g>
          <path d='M450.408,168.648C461.208,158.432,468,144.008,468,128c0-30.88-25.12-56-56-56s-56,25.12-56,56
			c0,19.648,10.192,36.936,25.544,46.928C370.968,182.136,364,194.264,364,208v56h-32v-40c0-28.624-21.6-52.272-49.36-55.568
			C293.312,158.232,300,143.896,300,128c0-30.88-25.12-56-56-56s-56,25.12-56,56c0,15.896,6.688,30.232,17.36,40.432
			C177.6,171.728,156,195.376,156,224v40h-32v-56c0-13.736-6.968-25.864-17.544-33.072C121.808,164.936,132,147.648,132,128
			c0-30.88-25.12-56-56-56s-56,25.12-56,56c0,16.008,6.792,30.432,17.592,40.648C18.592,171.736,4,188.136,4,208v120
			c0,19.312,13.768,35.472,32,39.192V488h16V368h72v112c0,4.416,3.584,8,8,8h48c4.416,0,8-3.584,8-8V352h48v120h-32v16h80v-16h-32
			V352h48v128c0,4.416,3.584,8,8,8h48c4.416,0,8-3.584,8-8V368h72v120h16V367.192c18.232-3.72,32-19.872,32-39.192V208
			C484,188.136,469.408,171.736,450.408,168.648z M372,128c0-22.056,17.944-40,40-40c22.056,0,40,17.944,40,40
			c0,22.056-17.944,40-40,40C389.944,168,372,150.056,372,128z M204,128c0-22.056,17.944-40,40-40c22.056,0,40,17.944,40,40
			c0,22.056-17.944,40-40,40C221.944,168,204,150.056,204,128z M256.456,184L244,217.216L231.544,184H256.456z M172,224
			c0-22.056,17.944-40,40-40h2.456l22.056,58.808c1.168,3.12,4.152,5.192,7.488,5.192s6.32-2.072,7.496-5.192L273.544,184H276
			c22.056,0,40,17.944,40,40v40h-32c-4.416,0-8,3.584-8,8v32h-64v-32c0-4.416-3.584-8-8-8h-32V224z M36,128
			c0-22.056,17.944-40,40-40c22.056,0,40,17.944,40,40c0,22.056-17.944,40-40,40C53.944,168,36,150.056,36,128z M172,472h-32V360
			c0-4.416-3.584-8-8-8H44c-13.232,0-24-10.768-24-24V208c0-13.232,10.768-24,24-24h40c13.232,0,24,10.768,24,24v64
			c0,4.416,3.584,8,8,8h80v24H84v-72H68v80c0,4.416,3.584,8,8,8h72c13.232,0,24,10.768,24,24V472z M300.896,336H187.104
			c-1.208-5.896-3.632-11.352-7.12-16H204h80h24.016C304.528,324.648,302.104,330.104,300.896,336z M468,328
			c0,13.232-10.768,24-24,24h-88c-4.416,0-8,3.584-8,8v112h-32V344c0-13.232,10.768-24,24-24h72c4.416,0,8-3.584,8-8v-80h-16v72H292
			v-24h80c4.416,0,8-3.584,8-8v-64c0-13.232,10.768-24,24-24h40c13.232,0,24,10.768,24,24V328z'
          />
        </g>
      </g>
      <g>
        <g>
          <rect x='236' y='264' width='16' height='16' />
        </g>
      </g>
      <g>
        <g>
          <path d='M204,0H92c-4.416,0-8,3.584-8,8v40c0,4.416,3.584,8,8,8h32v16c0,3.032,1.712,5.8,4.424,7.16
			c1.128,0.56,2.36,0.84,3.576,0.84c1.696,0,3.384-0.544,4.8-1.6L166.664,56H204c4.416,0,8-3.584,8-8V8C212,3.584,208.416,0,204,0z
			 M196,40h-32c-1.728,0-3.416,0.56-4.8,1.6L140,56v-8c0-4.416-3.584-8-8-8h-32V16h96V40z'
          />
        </g>
      </g>
      <g>
        <g>
          <rect x='284' y='24' width='16' height='16' />
        </g>
      </g>
      <g>
        <g>
          <rect x='316' y='24' width='16' height='16' />
        </g>
      </g>
      <g>
        <g>
          <rect x='348' y='24' width='16' height='16' />
        </g>
      </g>
    </svg>
  );
}
